import request from '@/utils/request.js';

export const ConversationChat = async (data, signal) => {
  const { message } = data;
  if (message && message.length > 0) {
    data.message = btoa(unescape(encodeURIComponent(message)));
  }
  return request(`/conversation/chat`, {
    method: 'POST',
    data,
    signal,
  });
};

export const fetchConversationId = async () => {
  return request(`/conversation/createConversation`, {
    method: 'POST',
    data: { reference: 'Web' },
  });
};

export const getAllConversations = async () => {
  return request(`/conversation/getAllConversations`, {
    method: 'GET',
  });
};

export const getConversationMessages = async (externalRef, userId) => {
  return request(`/conversation/${externalRef}/getConversationMessages`, {
    method: 'GET',
    params: {
      userId,
    },
  });
};

export const updateConversationNameAPI = async data => {
  return request(`/conversation/updateConversationName`, {
    method: 'POST',
    data,
  });
};

export const updateMessageByConversationER = async data => {
  return request(`/conversation/updateMassage`, {
    method: 'POST',
    data,
  });
};

export const deleteConversationApi = async externalRef => {
  return request(`/conversation/${externalRef}/deleteConversation`, {
    method: 'DELETE',
  });
};

export const getConversationApi = async externalRef => {
  return request(`/conversation/getConversationName/${externalRef}`, {
    method: 'GET',
  });
};

export const validateUserMuted = async data => {
  const { message } = data;
  if (message && message.length > 0) {
    data.message = btoa(unescape(encodeURIComponent(message)));
  }
  return request(`/conversation/validateUserMuted`, {
    method: 'POST',
    data,
  });
};

export const updateConversationAPI = async data => {
  return request(`/conversation/updateConversation`, {
    method: 'POST',
    data,
  });
};

export function getConversationIsFeedbackStatusAPI(fromData) {
  return request({
    url: `/conversation/getConversationIsFeedback`,
    method: 'GET',
    params: fromData,
  });
}
export function getConversationQuota() {
  return request({
    url: `/conversation/quota`,
    method: 'GET',
  });
}
